import { render, staticRenderFns } from "./tStockTables.vue?vue&type=template&id=8397cf06&scoped=true"
import script from "./tStockTables.vue?vue&type=script&lang=js"
export * from "./tStockTables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8397cf06",
  null
  
)

export default component.exports